import { Component, Input, ViewChild } from '@angular/core';

const HTML_TEMPLATE = `
<span #container class="thf-icon thf-icon-{{name}}"></span>
`;

@Component({
  selector: 'thf-icon',
  template: HTML_TEMPLATE
})
export class ThfIconComponent {

  @Input('name') name: string;
  @ViewChild('container') container: HTMLElement;

  constructor() {

  }
}
